import React from 'react';
import PropTypes from 'prop-types';

import { LinkElement } from '@els/els-react--link-element';
import Catalyst from '@Services/Catalyst';

import './NamedUser.scss';

function NamedUser({ userName, userLinkHandler, openLogoutDialog, closeFlyout, iconSize = 'xs', isSidePanel = false }) {
  const userNameFontClass = isSidePanel ? 'u-els-font-size-h3' : 'u-els-font-size-h4';
  const accountLinkFontClass = isSidePanel ? 'u-els-font-size-body-large' : undefined;

  return (
    <>
      {userName !== undefined && (
        <div id="named-user-username-list-item">
          <p className={`${userNameFontClass} u-els-margin-bottom-3o4`} aria-hidden="true">
            {userName}
          </p>
          <p className={`${userNameFontClass} u-els-margin-bottom-3o4 sr-only`}>Logged in as {userName}</p>
        </div>
      )}
      <ul>
        <li className="u-els-margin-bottom-1o2 u-els-font-size-body">
          <LinkElement
            data-e2e="named-user-profile"
            iconSprite="Researcher"
            iconSize={iconSize}
            className={accountLinkFontClass}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              Catalyst.trackContentLinkClick('header:navigation:profile');
              userLinkHandler();
              if (typeof closeFlyout === 'function') {
                closeFlyout();
              }
            }}
            a11y={{ name: 'Profile', description: 'Go to profile page' }}>
            Profile
          </LinkElement>
        </li>
        <li className="u-els-margin-bottom-1o2 u-els-font-size-body">
          <LinkElement
            data-e2e="named-user-sign-out"
            iconSprite="LogOut"
            iconSize={iconSize}
            className={accountLinkFontClass}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              Catalyst.trackContentLinkClick('header:navigation:sign-out');
              openLogoutDialog();
              if (typeof closeFlyout === 'function') {
                closeFlyout();
              }
            }}
            a11y={{ name: 'Logout', description: 'Logout from the application' }}>
            Sign out
          </LinkElement>
        </li>
      </ul>
    </>
  );
}

NamedUser.propTypes = {
  userName: PropTypes.string,
  userLinkHandler: PropTypes.func.isRequired,
  openLogoutDialog: PropTypes.func.isRequired,
  closeFlyout: PropTypes.func,
  iconSize: PropTypes.string,
  isSidePanel: PropTypes.bool,
};

export default NamedUser;
